import { Injectable } from '@angular/core';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  constructor(
    private apiCommonService: ApiCommonService,
    private commonService: CommonService
  ) {
  }

  getInsuranceRates(insuranceId: string): Observable<any> {
    return this.apiCommonService.get(`Insurance/Rates?InsuranceId=${insuranceId}`);
  }

  updateInsuranceRate(data: any): Observable<any> {
    return this.apiCommonService.post('Insurance/Update', data);
  }

  getInsuranceProviders(): Observable<any> {
    return this.apiCommonService.get(`Insurance/Providers`);
  }

  getCoverageCategories(): Observable<any> {
    return this.apiCommonService.get(`Insurance/CoverageCategory`);
  }

  getInsuranceRateMarkups(insuranceRateId: string): Observable<any> {
    return this.apiCommonService.get(`Insurance/MarkupTierList?InsuranceRateId=${insuranceRateId}`);
  }

  updateInsuranceRateMarkupTiers(data: any): Observable<any> {
    return this.apiCommonService.post(`Insurance/UpdateTiers`, data);
  }

  changeInsuranceProviderStatus(data: any): Observable<any> {
    return this.apiCommonService.put(`Insurance/ProviderStatus`, data);
  }

  changeInsuranceCategoryStatus(data: any): Observable<any> {
    return this.apiCommonService.put(`Insurance/CategoryStatus`, data);
  }

  getCategoriesLookup(InsuranceId: any): Observable<any> {
    return this.apiCommonService.get(`Insurance/CategoryLookup?InsuranceId=${InsuranceId}`);
  }

  getRateById(queryString: any): Observable<any> {
    return this.apiCommonService.get(`Insurance/RateById?${queryString}`);
  }
}
